module.exports = __webpack_public_path__ + "static/vf-button-earring.921c1640.svg";